import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Paragraph } from 'ViatoUi/Shared/Typo';

import styles from './AccommodationType.module.scss';

const AccommodationType = ({ adjustUnitAmountOnChange }) => {
	const { t } = useTranslation(['contractGenerator', 'translation']);
	const dispatch = useDispatch();

	const selectedAccommodationType = useSelector(contractGeneratorSelectors.getSelectedAccommodationType);
	const { ACCOMMODATION_TYPES_ORDER } = useSelector(contractGeneratorSelectors.getConstants);

	return (
		<>
			<Spacer height='s' />
			<Paragraph className={styles.headline} font='large'>
				<strong>{t('pages.step1.settingsArea.accommodationType.headline')}</strong>
			</Paragraph>
			<FlexBox alignItems='center' className={styles.accommodationTypes}>
				{ACCOMMODATION_TYPES_ORDER.map(accommodationType => (
					<FlexBox
						key={accommodationType.NAME}
						alignItems='center'
						className={styles.button}
						data={{ 'data-selected': selectedAccommodationType === accommodationType.NAME }}
						flexDirection='column'
						justifyContent='center'
						onClick={() => {
							const newData = { selectedAccommodationType: accommodationType.NAME };
							if (adjustUnitAmountOnChange) {
								newData.selectedRooms = accommodationType.DEFAULT_AMOUNT;
							}

							dispatch(contractGeneratorOperations.setDataToSubmit(newData));
						}}
					>
						<Icon className={styles.icon} color='silver' icon={accommodationType.ICON} iconWeight='fal' size='xl' />
						<Paragraph font='small'>{t(`translation:${accommodationType.TRANSLATION_PATH}`)}</Paragraph>
					</FlexBox>
				))}
			</FlexBox>
		</>
	);
};

AccommodationType.propTypes = {
	adjustUnitAmountOnChange: PropTypes.bool
};

AccommodationType.defaultProps = {
	adjustUnitAmountOnChange: true
};

export default AccommodationType;
